import React, { useEffect, useState } from 'react'
import { useLocalStorage } from 'usehooks-ts'

import { Menu, MenuPopover } from '../Menu'
import { NavItem } from './NavItem'
import { Dropdown } from './Dropdown'

export interface ChangelogEntry {
  created_at: string
  title: string
  url: string
}

export interface MenuLink {
  description: string
  forceRefresh: boolean
  isUnread: boolean
  name: string
  to: string
}

export const ChangelogMenu = ({ apiUrl }: { apiUrl: string }): JSX.Element => {
  const [changelogViewDate, setChangelogViewDate] = useLocalStorage('changelogViewDate', ' ')
  const [data, setData] = useState<ChangelogEntry[] | undefined>(undefined)
  const [isExpanded, setIsExpanded] = useState(false)
  const [isFetching, setIsFetching] = useState<boolean>(false)
  useEffect(() => {
    setIsFetching(true)

    async function fetchData() {
      try {
        const res = await fetch(apiUrl)
        const json = await res.json()
        setData(json?.entries)
        setIsFetching(false)
      } catch (err) {
        console.error(err)
        setIsFetching(false)
      }
    }

    fetchData()
  }, [])
  return (
    <Menu onOpenChange={setIsExpanded}>
      <NavItem changelogViewDate={changelogViewDate} entries={data} />
      <MenuPopover align="end">
        <Dropdown
          changelogViewDate={changelogViewDate}
          entries={data}
          isExpanded={isExpanded}
          loading={isFetching}
          setChangelogViewDate={setChangelogViewDate}
        />
      </MenuPopover>
    </Menu>
  )
}
